class BarreDefilanteQuotes extends HTMLElement {
  constructor() {
    super();
    this._intervalId = null;
    this._currentIndex = 0;
  }

  static get observedAttributes() {
    return ['data-interval'];
  }

  connectedCallback() {
    this._startRotation();
  }

  disconnectedCallback() {
    this._stopRotation();
  }

  _getSlides() {
    return Array.from(this.querySelectorAll('.barre-defilante__slide--quote'));
  }

  _getIntervalSeconds() {
    const val = parseInt(this.getAttribute('data-interval'), 10);
    return Number.isFinite(val) && val > 0 ? val : 5;
  }

  _startRotation() {
    this._stopRotation();
    const slides = this._getSlides();
    if (slides.length === 0) return;

    const intervalMs = this._getIntervalSeconds() * 1000;

    const rotate = () => {
      slides.forEach((slide, index) => {
        slide.classList.toggle('active', index === this._currentIndex);
      });
      this._currentIndex = (this._currentIndex + 1) % slides.length;
    };

    rotate();
    this._intervalId = setInterval(rotate, intervalMs);
  }

  _stopRotation() {
    if (this._intervalId) {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }
  }
}

customElements.define('barre-defilante-quotes', BarreDefilanteQuotes);
